import { sigmetTextKey } from './sigmetGeometry.js';

const ZONE_LAYERS = [
  ['sigmets-fill', 'sigmet'],
  ['sigmets-outline', 'sigmet'],
  ['areas-fill', 'area'],
  ['areas-outline', 'area'],
];

export function zoneKindFromFeatures(features) {
  const layerId = features?.[0]?.layer?.id;
  for (let i = 0; i < ZONE_LAYERS.length; i++) {
    if (ZONE_LAYERS[i][0] === layerId) return ZONE_LAYERS[i][1];
  }
  return null;
}

export function zonesFromFeatures(features, areaAtIndex) {
  const items = [];
  const seenSigmet = new Set();
  const seenArea = new Set();
  const list = features || [];

  for (let i = 0; i < list.length; i++) {
    const feature = list[i];
    const kind = zoneKindFromFeatures([feature]);
    if (kind === 'sigmet') {
      const rawText = feature?.properties?.rawSigmet || '';
      const textKey = sigmetTextKey(rawText);
      if (!textKey || seenSigmet.has(textKey)) continue;
      seenSigmet.add(textKey);
      items.push({
        kind: 'sigmet',
        hazard: feature?.properties?.hazard || '',
        rawText,
      });
      continue;
    }
    if (kind !== 'area') continue;
    const index = feature?.properties?.areaIndex;
    if (index === undefined || index === null || seenArea.has(String(index))) continue;
    seenArea.add(String(index));
    const area = areaAtIndex(index);
    if (!area) continue;
    items.push({ kind: 'area', area });
  }

  return items;
}

export function zonesAtPoint(map, point, areaAtIndex) {
  const present = [];
  for (let i = 0; i < ZONE_LAYERS.length; i++) {
    if (map.getLayer(ZONE_LAYERS[i][0])) present.push(ZONE_LAYERS[i][0]);
  }
  if (!present.length) return [];
  return zonesFromFeatures(
    map.queryRenderedFeatures(point, { layers: present }),
    areaAtIndex
  );
}

